import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";

const PlusButton = (props) => {
  return (
    <Button
      className="text-white flex items-center justify-center p-2 !bg-[#0dacce] 
      !border-[#0dacce] hover:!bg-[#0b9abb] hover:!border-[#0b9abb]
      hover:!text-white active:!text-white focus:!text-white"
      {...props}
    >
      <PlusOutlined />
    </Button>
  );
};

export default PlusButton;
